export default "__VITE_ASSET__DOUV6Rkd__"